<template lang="pug">
div(:style="'min-height:' + h")
  .px-0.white.detail-head.head-border
    el-row.pl-5
      el-col(:span="8")
        Breadcrumb(:data="items")
      el-col.pt-5.text-right(:span="15")
        el-button(
          type="primary",
          size="mini",
          :loading="loading",
          @click="dataLogic(0)"
          v-if="!disabled"
        ) 保存
        el-button(
          type="primary",
          size="mini",
          :loading="loading",
          @click="dataLogic(1)"
          v-if="!disabled&&(this.head.approval_status==-1||this.head.approval_status==0)"
        ) 保存并提交审核
        el-button(
          type="primary",
          size="mini",
          :loading="loading",
          @click="getApprove()"
          v-if="this.head.approval_status!=0"
        ) 审批信息
        el-button(type="primary", size="mini", @click="$router.go(-1)") 返回
  div(style="height: 70px")
  el-main.white.pa-3.ma-4
    el-row
      el-col(:span="20")
        div 考核信息
    el-form.mt-4(
      :model="head",
      ref="head",
      label-width="100px",
      size="mini",
      :rules="rules"
    )
      el-row
        el-col(:span="10")
          el-form-item(label="供应商", prop="supp_code")
            el-select.w-100(
              v-model="head.supp_code",
              filterable,
              remote,
              placeholder="请搜索供应商",
              :remote-method="getSupplyList",
              :loading="loadingSupply",
              @change="((value)=>{changeSupp(value)})",
              clearable,
              :disabled="disabled"
            )
              el-option(                  
                v-for="(item) in supply",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              )
          el-form-item(label="联系人/电话")
            el-input(
              v-model="head.contacts",
              placeholder="联系人/电话",
              disabled
            )         
          el-form-item(label="采购组织", prop="buy_org_id")
            el-select.w-100(
              v-model="head.buy_org_id",
              :filter-method="sourcebuyorg",
              filterable,
              placeholder="采购组织",
              @change="changeOrg",
              :disabled="disabled"
            )
              el-option(
                v-for="item in buyorg",
                :key="item.pk_org",
                :label="item.name",
                :value="item.pk_org"
              )    
          el-form-item(label="采购员")
            el-input(
              v-model="head.buy_person_name",
              placeholder="采购员",
              disabled
            )
        el-col(:span="10")
          el-form-item(label="地址")
            el-input(
              v-model="head.addr",
              placeholder="地址",
              disabled
            )                     
          el-form-item(label="企业性质")
            el-input(
              v-model="head.busi",
              placeholder="企业性质/纳税等级",
              disabled
            ) 
          el-form-item(label="采购部门", prop="buy_dept_id")
            el-select.w-100(
              v-model="head.buy_dept_id",
              placeholder="采购部门",
              @change="changeDept",
              filterable,
              :disabled="disabled"
            )
              el-option(
                v-for="item in dept",
                :key="item.pk_dept",
                :label="item.name",
                :value="item.pk_dept",
                :loading="loadingDept"
              )  
          el-form-item(label="评定周期",prop="period_code")
            el-select.w-100(
              size="mini",
              v-model="head.period_code",
              placeholder="评定周期",
              @change="changeVal1",
              :disabled="disabled"
            )
              el-option(
                v-for="item in pdzq",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              )       
      el-row
        el-col(:span="10")    
          el-form-item(label="等级评定",prop="level_code")
            el-select.w-100(
              size="mini",
              v-model="head.level_code",
              placeholder="等级评定",
              @change="changeVal2",
              :disabled="disabled"
            )
              el-option(
                v-for="item in djpd",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              ) 
        el-col(:span="10")      
          el-form-item(label="产品交付",prop="m1")
            el-select.w-100(
              size="mini",
              v-model="head.m1",
              placeholder="产品交付",
              :disabled="disabled"
            )
              el-option(
                v-for="item in ms",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              )         
      el-row
        el-col(:span="10")        
          el-form-item(label="售后服务",prop="m2")
            el-select.w-100(
              size="mini",
              v-model="head.m2",
              placeholder="售后服务",
              :disabled="disabled"
            )
              el-option(
                v-for="item in ms",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              ) 
          el-form-item(label="质量管控",prop="m3")
            el-select.w-100(
              size="mini",
              v-model="head.m3",
              placeholder="质量管控",
              :disabled="disabled"
            )
              el-option(
                v-for="item in ms",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              ) 
        el-col(:span="10")                 
          el-form-item(label="成本控制",prop="m4")
            el-select.w-100(
              size="mini",
              v-model="head.m4",
              placeholder="成本控制",
              :disabled="disabled"
            )
              el-option(
                v-for="item in ms",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              ) 
          el-form-item(label="综合能力",prop="m5")
            el-select.w-100(
              size="mini",
              v-model="head.m5",
              placeholder="综合能力",
              :disabled="disabled"
            )
              el-option(
                v-for="item in ms",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              ) 
      el-row
        el-col(:span="21")
          el-form-item(label="备注")
            el-input(v-model="head.remark", placeholder="请输入",:disabled="disabled")
    el-row
      el-col(:span="20")
        div 附件
          span (最多支持上传5个附件)
    el-form.mt-4(
      :data="attachments",
      label-width="100px",
      size="mini",
      :rules="rules"
    )      
      el-row
        el-col(:span="7")
          el-upload(
            :headers="http_header",
            :action="pathfile",
            :on-success="handleFileSuccess",
            :on-remove="handleRemoveFile",
            :limit="5",
            :on-exceed="handleExceedFile",
            :on-preview="handleFilePreview",
            :file-list="fileList"
          )
            el-button(size="small", type="primary",v-if="!disabled") 点击上传附件
  el-dialog(
    title="审批信息",
    :visible.sync="dialogVisible",
    width="500px",
    :close-on-click-modal="true",
    :close-on-press-escape="false"
  )
    el-timeline(:reverse="true")
      el-timeline-item(
        v-for="(item, index) in approve",
        :key="index",
        :timestamp="item.time"
      )
        div {{ item.nodename + " : " + item.approver }}
        div(v-if="item.opinion") 审批意见 : {{ item.opinion }}            
</template>
<script>
import { url } from "@/utils/config";
import _ from "lodash";

export default {
  data() {
    return {
      disabled: false,
      url: url,
      h: "",
      data: {},
      dialogVisible: false,
      head: {
        buy_person_name: this.$store.state.user.name,
        buy_person_id: this.$store.state.user.pk_psndoc,
        approval_status: 0,
        approval_person: null,
        approval_time: null,
        approval_remark: null,
        approval_id: null,
        id: null,
        addr: "",
        contacts: "",
        busi: null,
        supp_code: "",
        supp_name: "",
        remark: "",
        buy_org_id: "",
        buy_org_name: "",
        buy_dept_id: "",
        buy_dept_name: "",
        period_code: "",
        period_name: "",
        level_code: "",
        level_name: "",
        m1: "",
        m2: "",
        m3: "",
        m4: "",
        m5: "",
        dr: 0
      },
      items: [
        {
          path: this.$route.path,
          meta: {
            title: "详情",
          },
        },
      ],
      dept: [],
      pdzq: [],
      djpd: [],
      ms: [
        {
          code: 'A',
          name: 'A'
        },
        {
          code: 'B',
          name: 'B'
        },
        {
          code: 'C',
          name: 'C'
        },
        {
          code: 'D',
          name: 'D'
        },
        {
          code: 'E',
          name: 'E'
        },
      ],
      loadingDept: false,
      loading: false,
      loadingSupply: false,
      supply: [],
      supplyMap: null,
      time: "",
      rules: {
        supp_code: [
          { required: true, message: "请选择供应商", trigger: "change" },
        ],
        buy_org_id: [
          { required: true, message: "请选择采购组织", trigger: "change" },
        ],
        buy_dept_id: [
          { required: true, message: "请选择部门", trigger: "change" },
        ],
        busi: [
          { required: true, message: "请填写企业性质", trigger: "blur" },
        ],
        period_code: [
          { required: true, message: "请选择评定周期", trigger: "change" },
        ],
        level_code: [
          { required: true, message: "请选择等级评定", trigger: "change" },
        ],
      },
      list: {},
      count: 0,
      detail_data: [],
      dialogTableVisible: false,
      dialogTableVisible1: false,
      pathfile: this.$api.file.upload_file,
      path: this.$api.file.upload_file,
      file_path: null,
      fileList: [], attachments: [],
      files: {
        name: null,
        size: 0,
        uid: 0,
      },
    };
  },
  methods: {
    handleRemoveFile(file, fileList) {
      this.fileList = fileList;
    },
    handleFilePreview(file) {
      window.open(url + file.file_path);
    },
    handleFileSuccess(res, file, fileList) {
      if (res.code == 200) {
        for (let n = 0; n < fileList.length; n++) {
          if (n == fileList.length - 1) {
            this.fileList.push({
              uid: fileList[n].uid,
              file_path: res.data,
              name: fileList[n].name,
            });
          }
        }
      } else {
        this.$notify({
          message: res.msg,
          type: "error",
        });
      }
    },
    handleExceedFile(files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    changeOrg(e) {
      this.head.buy_dept_id = null;
      this.head.buy_dept_name = null;
      for (var i in this.purchase_org) {
        if (e == this.purchase_org[i].pk_org) {
          this.head.buy_org_name = this.purchase_org[i].name;
        }
      }
      this.getDept(e);
    },
    changeDept(e) {
      for (var i in this.dept) {
        if (e == this.dept[i].pk_dept) {
          this.head.buy_dept_name = this.dept[i].name;
        }
      }
    },
    async getApprove() {
      this.loading = true;
      let res = await this.$api.global.getApprove('se', this.head.approval_id, this.head.approval_id);
      this.loading = false;
      this.dialogVisible = true;
      if (res) {
        this.approve = res.data;
      } else {
        this.approve = [];
      }
    },
    changeSupp(e) {
      this.head.supp_code = e;
      const mapVal = this.supplyMap.get(e)
      this.head.supp_name = mapVal.name;
      this.head.addr = mapVal.address
      this.head.contacts = mapVal.contact + ' | ' + mapVal.contact_phone
      this.head.busi = mapVal.tax_class
    },
    changeVal1(e) {
      for (var i in this.pdzq) {
        if (e == this.pdzq[i].code) {
          this.head.period_name = this.pdzq[i].name;
        }
      }
    },
    changeVal2(e) {
      for (var i in this.djpd) {
        if (e == this.djpd[i].code) {
          this.head.level_name = this.djpd[i].name;
        }
      }
    },
    async getSupplyList(query) {
      if (!query) {
        return false;
      }
      this.loadingSupply = true;
      let res = await this.$api.supplier.getotherList({
        key_name: query,
        page_num: 1,
        page_size: 100,
        no_check: 1,
        checkstatus: 3,
      });
      this.loadingSupply = false;
      if (res) {
        this.supply = res.data;
        this.supplyMap = new Map();
        this.supply.forEach(object => {
          this.supplyMap.set(object.code, object);
        });
      }
    },
    async getDept(e) {
      if (e) {
        this.loadingDept = true;
        let res = await this.$api.global.deptList({
          pk_org: e,
        });
        this.loadingDept = false;
        if (res) {
          this.dept = res.data;
        }
      } else {
        this.dept = [];
      }
    },
    async getFile() {
      this.loading = true;
      let res = await this.$api.file.getFile(this.$route.params.id);
      this.loading = false;
      if (res) {
        //this.filelist = res.data
        for (let i = 0; i < res.data.length; i++) {
          this.j = i + 1;
          this.fileList.push({
            uid: res.data[i].id,
            file_path: res.data[i].file_path,
            busi_id: res.data[i].busi_id,
            dr: res.data[i].dr,
            name: res.data[i].prefix_name + "." + res.data[i].suffix_name,
          });
        }
      }
    },
    async getById() {
      this.loading = true;
      let res = await this.$api.supp_eval.getById(this.$route.params.id);
      this.loading = false;
      if (res) {
        this.head = res.data;
        this.getSupplyList(this.head.supp_name);
        this.getDept(this.head.buy_org_id);
      }
    },
    async dataLogic(type) {
      let flag = true;
      this.$refs["head"].validate((valid) => {
        if (!valid) {
          flag = false;
        }
      });
      if (!flag) {
        return false;
      }
      if (this.fileList.length == 0) {
        this.$notify({
          message: "请上传附件",
          type: "error",
        });
        return false;
      }
      const busiVal = this.head.busi
      if (busiVal == 'undefined' || busiVal == null || busiVal.trim() == '') {
        this.$notify({
          message: "请填写企业性质",
          type: "error",
        });
        return false;
      }
      this.attachments = [];
      for (let i = 0; i < this.fileList.length; i++) {
        this.attachments.push({
          busi_id: this.head.id,
          file_path: this.fileList[i].file_path,
          prefix_name: this.fileList[i].name.substring(
            0,
            this.fileList[i].name.lastIndexOf(".")
          ),
          suffix_name: this.fileList[i].name.substring(
            this.fileList[i].name.lastIndexOf(".") + 1
          ),
          dr: 0,
          id: this.fileList[i].uid,
        });
      }
      this.data.head = this.head;
      this.data.attachments = this.attachments;
      let res = null;
      this.loading = true;
      const prev_status = this.head.approval_status
      if (type == 0) {
        res = await this.$api.supp_eval.edit(this.data);
      } else {
        //发起审批
        this.data.head.approval_status = 1
        res = await this.$api.supp_eval.edit(this.data);
      }
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      } else {
        this.head.approval_status = prev_status
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();

    if (this.$route.params.type == 1) {
      if (this.$route.params.id == -1) {
        this.items[0].meta.title = "新增";
      } else {
        this.items[0].meta.title = "编辑";
      }
    } else {
      this.disabled = true;
    }
    if (this.$route.params.id != -1) {
      this.getById();
      this.getFile();
    }


    this.getDefdoc(this, { code: "pdzq" });
    this.getDefdoc(this, { code: "djpd" });
  },
  computed: {
    buy_org_c: {
      get: function () {
        if (this.head.buy_org_id == null) {
          return null;
        }
        return {
          purchase_org: this.head.buy_org_id,
          def19: this.head.buy_org_name,
        };
      },
      set: function (val) {
        this.head.buy_org_id = val.pk_org;
        this.head.buy_org_name = val.def19;
      },
    },
  },
  watch: {
  },
};
</script>